import {EventSource} from './event-source';
import {GlobalEvents} from './global-events';

export class EventBus extends EventSource {
    public on<T extends keyof GlobalEvents>(name: T, callback: GlobalEvents[T]): number {
        return super.on(name, callback);
    }

    public emit<T extends keyof GlobalEvents>(name: T, ...args: Parameters<GlobalEvents[T]>): void {
        super.emit(name, ...args);
    }
}

export const eventBus: EventBus = new EventBus();
